import { render, staticRenderFns } from "./MitigationCommentPreview.vue?vue&type=template&id=3fa6d7ec&"
import script from "./MitigationCommentPreview.vue?vue&type=script&lang=js&"
export * from "./MitigationCommentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports